import React from "react";
import "./Contact.css";
import mosqueImg from "../assets/Screenshot_2025_1215_183253.png"; // mosque image

export default function Contact() {
  return (
    <div className="contact-page">

      {/* Hero Section */}
      <div className="contact-hero">
        <img src={mosqueImg} alt="Mosque" />
        <div className="hero-overlay">
          <h1>Get in Touch</h1>
          <p>
            Connect with us for any questions, suggestions, or community events.
          </p>
        </div>
      </div>

      {/* Main Section */}
      <div className="contact-container">

        {/* Info Cards Section */}
        <section className="contact-info">
          <div className="info-card">
            <h3>📧 Email</h3>
            <p>info@moshiqe.com</p>
          </div>
          <div className="info-card">
            <h3>📞 Phone</h3>
            <p>+123 456 7890</p>
          </div>
          <div className="info-card">
            <h3>📍 Address</h3>
            <p>123 Mosque Street, City, Country</p>
          </div>

        </section>

        {/* Social Media Section */}
        <section className="contact-social">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer">YouTube</a>
            <a href="tel:+8801XXXXXXXXX">Call</a>
            <a href="mailto:example@gmail.com">Email</a>

          </div>
        </section>

        {/* Contact Form Section */}
        <section className="contact-form">
          <h3>Send a Message</h3>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit">Send Message</button>
        </section>
      </div>
    </div>
  );
}
